<template>
    <div data-app>
        
        <div>
            <v-data-table
                :headers="headers"
                :items="history"
                :items-per-page="-1"
                hide-default-footer
                class="elevation-1"
                >
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Passolig Süreç Geçmişi</v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.from`]="{item}">
                    <b-badge class="mr-1" :variant="getClass(item.from)">{{ item.from }}</b-badge>
                </template>
                <template v-slot:[`item.to`]="{item}">
                    <b-badge class="mr-1" :variant="getClass(item.to)">{{ item.to }}</b-badge>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                    <span>{{ item.created_at | formatDateTime }}</span>
                </template>   
            </v-data-table>
            
        </div>  
    </div>
</template>

<script>
import { GET_PASSOLIG_HISTORY } from "@/core/services/store/passoligs.module";

import { mapState} from 'vuex';
import { mapGetters} from 'vuex';


export default {
    name: "passolig-history-component",
    data () {
        
        return {
            history:[],
            title_history: "Passolig Değerlendirme Süreci",
            headers: [
                { text: "Eski Statü", align: "start", value: "from" },
                { text: "Yeni Statü", align: "start", value: "to" },
                { text: "Açıklamalar", value: "custom_properties.comments" },
                { text: "İlgili", value: "responsible.name" },
                { text: "Tarih", value: "created_at" },
               
            ], 
            dialog: false,
            
        }
    },
    props: ['passolig_id', 'formTypeHistory'],
   
    components: {

    },

    created () {
        var id = this.passolig_id;
        if(this.formTypeHistory !== "add") {
           this.getPassoligHistory(id);
        }
    },

    methods : {
        getPassoligHistory(id) {
            this.$store.dispatch(GET_PASSOLIG_HISTORY, { id })
            .then((response) => {
                this.history = response.data;
            })
        },

        getClass(status) {
            if (status == "Onay Bekliyor") return 'warning';
            if (status == "Onaylandı") return 'primary';
            if (status == "Reddedildi") return 'danger';
            if (status == "Düzeltilmesi İçin Geri Gönderildi") return 'info';
            if (status == "Üye Tarafından Düzeltildi") return 'dark';
        },
    },

    

    computed: {
        ...mapGetters(["currentUserMenu"]),
        ...mapState({
            loading: state => state.passoligs.loading,
            row: state => state.passoligs.row,
            errors: state => state.passoligs.errors,
            isDisabled: state => state.passoligs.isDisabled,
        })
    }

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}
</style>